import React, {PureComponent} from 'react';
import $ from "jquery";
import ReactTooltip from 'react-tooltip';
import {degToCompass, padDigits} from "../functions/utils";
import Toggle from 'react-bootstrap-toggle';

import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css';
import {withTranslation} from "react-i18next";

import Moment from 'moment-timezone';

// in seconds
const weatherRefresh = 120;

class MiddleRow extends PureComponent {

    render() {
        return (
            <div className={"row row-flex"} style={{marginTop: 10}}>
                <Clock
                    circuitTimezone={this.props.circuitTimezone}
                    t={this.props.t}
                />
                <Weather
                    eventID={this.props.eventID}
                    mapCenterLat={this.props.mapCenterLat}
                    mapCenterLng={this.props.mapCenterLng}
                    t={this.props.t}
                />
            </div>
        );
    }
}

class Clock extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            toggleTimezone: true,
            timeToShow: "--:--:--",
        };

        this.onToggleTimezone = this.onToggleTimezone.bind(this);
        this.restartClock = this.restartClock.bind(this);
    }

    componentDidMount() {
        this.restartClock();
    }

    componentWillUnmount() {
        clearInterval(this.clockInterval);
    }

    onToggleTimezone() {
        this.setState({
            toggleTimezone: !this.state.toggleTimezone,
        }, () => {
            this.restartClock();
        });
    }

    restartClock() {
        // Set clock in motion
        clearInterval(this.clockInterval);
        this.clockInterval = setInterval(() => {
            let date, hours, minutes, seconds;
            if (this.state.toggleTimezone) {
                date = new Date();
                hours = date.getHours();
                minutes = date.getMinutes();
                seconds = date.getSeconds();
            } else {
                date = Moment().tz(this.props.circuitTimezone);
                hours = date.hours();
                minutes = date.minutes();
                seconds = date.seconds();
            }

            this.setState({
                timeToShow: padDigits(hours, 2) + ":" + padDigits(minutes, 2) + ":" + padDigits(seconds, 2),
            });
        }, 1000);
    }

    render() {
        return (
            <div className={"col-xs-3 hidden-xs hidden-sm"} style={{whiteSpace: "nowrap"}}>
                <Toggle
                    onClick={this.onToggleTimezone}
                    on={<h5 className={"App_white_text"}>{this.props.t("local").toUpperCase()}</h5>}
                    off={<h5 className={"App_white_text"}>{this.props.t("track").toUpperCase()}</h5>}
                    size={"xs"}
                    onstyle={"danger"}
                    offstyle={"danger"}
                    handlestyle={"success"}
                    height={"100%"}
                    style={{borderRadius: 10, float: "left"}}
                    active={this.state.toggleTimezone}
                />
                <div className={"App_clockContainer vcenter"}>
                    <span className={"App_clockFontStyle"}>
                        {this.state.timeToShow}
                    </span>
                </div>
            </div>
        );
    }
}

class Weather extends PureComponent {

    interval = null;

    constructor(props) {
        super(props);

        this.state = {
            temp: "---",
            hum: "---",
            clouds: "---",
            wind: "---",
            windDirection: "---",
            mapCenterLat: this.props.mapCenterLat,
            mapCenterLng: this.props.mapCenterLng,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.mapCenterLat !== this.props.mapCenterLat) {
            this.updateWeather();
        }
    }

    updateWeather() {
        const helper = this;
        $.ajax({
            url: 'https://api.openweathermap.org/data/2.5/weather?lat=' + helper.props.mapCenterLat + '&lon=' + helper.props.mapCenterLng + '&APPID=ff882111baa3db2189041efb2879cdb9',
            type: 'GET',
            dataType: 'json',
            success: (result) => {
                helper.setState({
                    temp: Math.round(result.main.temp - 273.15),
                    hum: Math.round(result.main.humidity),
                    clouds: result.clouds.all,
                    wind: ((Math.round(result.wind.speed * 100) / 100) * 3.6).toFixed(2),
                    windDirection: degToCompass(result.wind.deg),
                });
                console.log("[DASHBOARD] UPDATED WEATHER");
            },
            error: (err) => {
                console.log("[DASHBOARD] ERROR fecthing weather info", err);
            },
        });
    }

    componentDidMount() {
        this.updateWeather();
        this.interval = setInterval(() => this.updateWeather(), weatherRefresh * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div className={"col-xs-12 col-md-9"} style={{display: "flex", justifyContent: "space-between"}}>
                <div className={"col-xs-2 weatherWidgetStyle"} data-tip={true} data-for={"ambientTemp"}>
                    <i className={"fas fa-thermometer-half fa-2x iconStyle"}/>
                    <span className={"weatherWidgetTextStyle"}>{this.state.temp} ºC</span>
                </div>
                <div className={"col-xs-2 weatherWidgetStyle"} data-tip={true} data-for={"ambientHum"}>
                    <i className={"fas fa-tint fa-2x iconStyle"}/>
                    <span className={"weatherWidgetTextStyle"}>{this.state.hum}%</span>
                </div>
                <div className={"col-xs-2 weatherWidgetStyle"} data-tip={true} data-for={"cloudiness"}>
                    <i className={"fas fa-cloud iconStyle"}/>
                    <span className={"weatherWidgetTextStyle"}>{this.state.clouds}%</span>
                </div>
                <div className={"col-xs-3 weatherWidgetStyle"} data-tip={true} data-for={"windSpeed"}>
                    <i className={"fa fa-flag fa-2x iconStyle"} aria-hidden="true"/>
                    <span className={"weatherWidgetTextStyle"}>{this.state.wind} km/h</span>
                </div>
                <div className={"col-xs-2 weatherWidgetStyle"} data-tip={true} data-for={"windDirection"}>
                    <i className={"far fa-compass iconStyle"}/>
                    <span className={"weatherWidgetTextStyle"}>{this.state.windDirection}</span>
                </div>

                <ReactTooltip id={"ambientTemp"} type={"light"}>
                    <span className={"toolTipStyle"}>{this.props.t("ambientTemperature")}</span>
                </ReactTooltip>
                <ReactTooltip id={"ambientHum"} type={"light"}>
                    <span className={"toolTipStyle"}>{this.props.t("humidity")}</span>
                </ReactTooltip>
                <ReactTooltip id={"cloudiness"} type={"light"}>
                    <span className={"toolTipStyle"}>{this.props.t("cloudiness")}</span>
                </ReactTooltip>
                <ReactTooltip id={"windSpeed"} type={"light"}>
                    <span className={"toolTipStyle"}>{this.props.t("windSpeed")}</span>
                </ReactTooltip>
                <ReactTooltip id={"windDirection"} type={"light"}>
                    <span className={"toolTipStyle"}>{this.props.t("windDirection")}</span>
                </ReactTooltip>
            </div>
        );
    }
}

export default withTranslation("translations")(MiddleRow);
